var pug = require("!../../../node_modules/pug/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (BemEntity, buttons, classSuffixer, heading, modalClassName, modalHasBackdrop, modalHasCloseButton, modalHasHeader, modalTitle, subheading) {
      const modalClassSuffixer = classSuffixer(modalClassName)
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('wrapper')], [true]), false, true)) + "\u003E";
if (modalHasBackdrop) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('backdrop')], [true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('content')], [true]), false, true)) + "\u003E";
if (modalHasHeader) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('header')], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('title')], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = modalTitle) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (modalHasCloseButton) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([modalClassSuffixer('close-button')], [true]), false, true)) + "\u003E\u003Ci class=\"mdi-navigation-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('body')], [true]), false, true)) + "\u003E";
const bem = BemEntity('confirm-modal')
if (heading) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('heading')], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = heading) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (subheading) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('subheading')], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = subheading) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('buttons-container')], [true]), false, true)) + "\u003E";
// iterate buttons
;(function(){
  var $$obj = buttons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var button = $$obj[pug_index0];
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('button', { primary: button.primary })], [true]), false, true)+pug.attr("data-value", button.value, true, true)+pug.attr("data-value-type", button.valueType, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button.label) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var button = $$obj[pug_index0];
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('button', { primary: button.primary })], [true]), false, true)+pug.attr("data-value", button.value, true, true)+pug.attr("data-value-type", button.valueType, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button.label) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "BemEntity" in locals_for_with ?
        locals_for_with.BemEntity :
        typeof BemEntity !== 'undefined' ? BemEntity : undefined, "buttons" in locals_for_with ?
        locals_for_with.buttons :
        typeof buttons !== 'undefined' ? buttons : undefined, "classSuffixer" in locals_for_with ?
        locals_for_with.classSuffixer :
        typeof classSuffixer !== 'undefined' ? classSuffixer : undefined, "heading" in locals_for_with ?
        locals_for_with.heading :
        typeof heading !== 'undefined' ? heading : undefined, "modalClassName" in locals_for_with ?
        locals_for_with.modalClassName :
        typeof modalClassName !== 'undefined' ? modalClassName : undefined, "modalHasBackdrop" in locals_for_with ?
        locals_for_with.modalHasBackdrop :
        typeof modalHasBackdrop !== 'undefined' ? modalHasBackdrop : undefined, "modalHasCloseButton" in locals_for_with ?
        locals_for_with.modalHasCloseButton :
        typeof modalHasCloseButton !== 'undefined' ? modalHasCloseButton : undefined, "modalHasHeader" in locals_for_with ?
        locals_for_with.modalHasHeader :
        typeof modalHasHeader !== 'undefined' ? modalHasHeader : undefined, "modalTitle" in locals_for_with ?
        locals_for_with.modalTitle :
        typeof modalTitle !== 'undefined' ? modalTitle : undefined, "subheading" in locals_for_with ?
        locals_for_with.subheading :
        typeof subheading !== 'undefined' ? subheading : undefined));
    ;;return pug_html;};
module.exports = template;